const undergraduaterRouter = [
  {
    path: '/undergraduate',
    name: 'undergraduate-home',
    redirect: '/undergraduate/index',
    component: () => import('@/view/undergraduate/home'),
    children: [
      {
        path: 'index',
        name: 'undergraduate-index',
        meta: {
          menu: 'home'
        },
        component: () => import('@/view/undergraduate/home/home-main')
      },
      // 绑定微信
      {
        path: 'wechat',
        name: 'undergraduate-wechat',
        meta: {
          menu: 'home'
        },
        component: () => import('@/view/undergraduate/home/wechat')
      },
      // 问题反馈
      {
        path: 'feedback',
        name: 'undergraduate-feedback',
        meta: {
          menu: 'home'
        },
        component: () => import('@/view/undergraduate/home/feedback')
      },
      // 简历信息表
      {
        path: 'cv',
        name: 'undergraduate-cv-index',
        meta: {
          menu: 'cv'
        },
        redirect: '/undergraduate/cv/cn',
        component: () => import('@/view/undergraduate/cv'),
        children: [
          {
            path: 'cn',
            name: 'undergraduate-cv-cn',
            meta: {
              lang: 'cn',
              menu: 'cv'
            },
            redirect: '/undergraduate/cv/cn/base',
            component: () => import('@/view/undergraduate/cv/cv-cn'),
            children: [
              {
                path: 'base',
                name: 'undergraduate-cv-cn-base',
                meta: {
                  lang: 'cn',
                  kind: 'base',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-base')
              },
              {
                path: 'family',
                name: 'undergraduate-cv-cn-family',
                meta: {
                  lang: 'cn',
                  kind: 'family',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-family')
              },
              {
                path: 'education',
                name: 'undergraduate-cv-cn-education',
                meta: {
                  lang: 'cn',
                  kind: 'education',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-education')
              },
              {
                path: 'course',
                name: 'undergraduate-cv-cn-course',
                meta: {
                  lang: 'cn',
                  kind: 'course',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-course')
              },
              {
                path: 'score',
                name: 'undergraduate-cv-cn-score',
                meta: {
                  lang: 'cn',
                  kind: 'score',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-score')
              },
              {
                path: 'credit',
                name: 'undergraduate-cv-cn-credit',
                meta: {
                  lang: 'cn',
                  kind: 'credit',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-credit')
              },
              {
                path: 'awards',
                name: 'undergraduate-cv-cn-awards',
                meta: {
                  lang: 'cn',
                  kind: 'awards',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-awards')
              },
              {
                path: 'activity',
                name: 'undergraduate-cv-cn-activity',
                meta: {
                  lang: 'cn',
                  kind: 'activity',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-activity')
              },
              {
                path: 'hobby',
                name: 'undergraduate-cv-cn-hobby',
                meta: {
                  lang: 'cn',
                  kind: 'hobby',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-hobby')
              }
            ]
          },
          {
            path: 'en',
            name: 'undergraduate-cv-en',
            meta: {
              lang: 'en',
              menu: 'cv'
            },
            redirect: '/undergraduate/cv/en/base',
            component: () => import('@/view/undergraduate/cv/cv-en'),
            children: [
              {
                path: 'base',
                name: 'undergraduate-cv-en-base',
                meta: {
                  lang: 'en',
                  kind: 'base',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-base')
              },
              {
                path: 'family',
                name: 'undergraduate-cv-en-family',
                meta: {
                  lang: 'en',
                  kind: 'family',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-family')
              },
              {
                path: 'education',
                name: 'undergraduate-cv-en-education',
                meta: {
                  lang: 'en',
                  kind: 'education',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-education')
              },
              {
                path: 'course',
                name: 'undergraduate-cv-en-course',
                meta: {
                  lang: 'en',
                  kind: 'course',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-course')
              },
              {
                path: 'score',
                name: 'undergraduate-cv-en-score',
                meta: {
                  lang: 'en',
                  kind: 'score',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-score')
              },
              {
                path: 'credit',
                name: 'undergraduate-cv-en-credit',
                meta: {
                  lang: 'en',
                  kind: 'credit',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-credit')
              },
              {
                path: 'awards',
                name: 'undergraduate-cv-en-awards',
                meta: {
                  lang: 'en',
                  kind: 'awards',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-awards')
              },
              {
                path: 'activity',
                name: 'undergraduate-cv-en-activity',
                meta: {
                  lang: 'en',
                  kind: 'activity',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-activity')
              },
              {
                path: 'hobby',
                name: 'undergraduate-cv-en-hobby',
                meta: {
                  lang: 'en',
                  kind: 'hobby',
                  menu: 'cv'
                },
                component: () => import('@/view/undergraduate/cv/cv-hobby')
              }
            ]
          }
        ]
      },
      // 服务管理
      {
        path: 'service',
        name: 'undergraduate-service-index',
        meta: {
          menu: 'service'
        },
        redirect: '/undergraduate/service/guidance',
        component: () => import('@/view/undergraduate/service-management'),
        children: [
          // 套餐信息
          /*{
            path: 'package',
            name: 'undergraduate-service-package',
            meta: {
              kind: 'package',
              menu: 'service'
            },
            component: () =>
              import('@/view/undergraduate/service-management/service-package')
          },*/
          // 导师辅导
          {
            path: 'guidance',
            name: 'undergraduate-service-guidance',
            meta: {
              kind: 'guidance',
              menu: 'service'
            },
            component: () =>
              import('@/view/undergraduate/service-management/service-guidance')
          },
          // 服务团队
          {
            path: 'team',
            name: 'undergraduate-service-team',
            meta: {
              kind: 'team',
              menu: 'service'
            },
            component: () =>
              import('@/view/undergraduate/service-management/service-team')
          }
        ]
      },
      // 选校管理
      /*{
        path: 'school',
        name: 'undergraduate-school-index',
        meta: {
          menu: 'school'
        },
        component: () => import('@/view/undergraduate/school')
      },*/
      // 须知文档
      {
        path: 'attention',
        name: 'undergraduate-attention-index',
        meta: {
          menu: 'attention'
        },
        redirect: {
          name: 'undergraduate-attention-manual'
        },
        component: () => import('@/view/undergraduate/attention'),
        children: [
          {
            path: 'manual',
            name: 'undergraduate-attention-manual',
            component: () => import('@/view/undergraduate/attention/manual')
          }
        ]
      },
      // 个人信息
      {
        path: 'personal',
        name: 'undergraduate-personal-index',
        redirect: {
          name: 'undergraduate-personal-message'
        },
        component: () => import('@/view/undergraduate/personal'),
        children: [
          {
            path: 'message',
            name: 'undergraduate-personal-message',
            component: () =>
              import('@/view/undergraduate/personal/personal-message')
          },
          {
            path: 'modify-password',
            name: 'undergraduate-personal-modify-password',
            component: () =>
              import('@/view/undergraduate/personal/personal-modify-password')
          }
        ]
      }
    ]
  }
]
export default undergraduaterRouter
